import './Banner.scss';

class Banner {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['Banner'] = Banner;
export default Banner;
